import { IContext } from "@src/context";
import { IProperty } from "./types";

import fetchPropertiesJson from "../SearchResult/propertiesFetcher/allProperties";

const baseUrl = document.body.getAttribute("data-site-domain") || "";
const apiUrl = `${baseUrl}/vhmserverapi.FeaturedPropertiesService/FeaturedProperties`;

function fetchFeaturedPropertiesId(containerId: string) {
  return fetch(apiUrl, {
    credentials: "include",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      container_id: containerId,
    }),
  })
    .then((response) => {
      if (response.status != 200) {
        throw new Error(
          `Failed to call filter properties, status: ${response.status} on url ${apiUrl}`
        );
      }
      return response.json();
    })
    .then((response) => response?.ids || []);
}

export function fetchFeaturedProperties(
  context: IContext,
  containerId: string
): Promise<IProperty[]> {
  return Promise.all([
    fetchFeaturedPropertiesId(containerId),
    fetchPropertiesJson(context),
  ]).then(([ids, properties]) => {
    return ids
      .map((id: number) => properties.find((property) => property.id === id))
      .filter(Boolean);
  });
}
